import React, { Component } from 'react';

export default class Modal extends Component {
	constructor(props) {
		super(props);
		this.state = { popupBg: 'popup-bg', popUpInner: 'popup-inner' };
	}

	componentDidMount() {
		this.fadeIn();
	}

	fadeIn = () => {
		setTimeout(() => {
			this.setState({
				popupBg: 'popup-bg open',
				popUpInner: 'popup-inner open'
			});
		}, 50);
	}

	fadeOut = () => {
		setTimeout(() => {
			this.setState({
				popupBg: 'popup-bg',
				popUpInner: 'popup-inner'
			});
			setTimeout(() => {
				this.props.onClose();
			}, 700);
		}, 0);
	}

	render() {
		return(
			<div>
				<div className={this.state.popUpInner}>
					<button className='close-modal-btn' onClick={this.fadeOut.bind(this)}>
						&times;
					</button>
					{this.props.text}
				</div>
				<div className={this.state.popupBg} onClick={this.fadeOut.bind(this)} />
			</div>
		);
	}
}